/* unplugin-vue-components disabled */import { render } from "./HandlePostersSetting.vue?vue&type=template&id=869f1c18"
import script from "./HandlePostersSetting.vue?vue&type=script&lang=js"
export * from "./HandlePostersSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__